/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  lightThemePrimitives as baseuiLightThemePrimitives,
  darkThemePrimitives as baseuiDarkThemePrimitives,
} from "baseui"
import emotionLightTheme from "./emotionLightTheme"
import emotionDarkTheme from "./emotionDarkTheme"
import { createBaseUiTheme } from "./createThemeUtil"

export const baseuiLightTheme = createBaseUiTheme(
  emotionLightTheme,
  baseuiLightThemePrimitives
)

export const baseuiDarkTheme = createBaseUiTheme(
  emotionDarkTheme,
  baseuiDarkThemePrimitives
)

export type BaseUILightTheme = typeof baseuiLightTheme
